/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { Context } from '../../../../context/AppContext';

import './styles.css';

const CheckBox = ({ children, svg = () => {}, className, ...props }) => {
  const {
    media: { desktop },
  } = useContext(Context);
  const [hovered, setHovered] = useState();
  const [isChecked, setIsChecked] = useState(props.defaultChecked);
  const onChange = e => {
    const { target } = e || {};
    const { checked } = target || {};
    setIsChecked(checked);
  };
  return (
    <label
      hasfor={props.name}
      className={classNames('Listview__Filters__CheckBox__root', {
        [className]: className,
        'Listview__Filters__CheckBox__root--disabled': props.disabled,
        'Listview__Filters__CheckBox__root--hovered': desktop && hovered,
        'Listview__Filters__CheckBox__root--checked': isChecked,
      })}
      onMouseEnter={() => {
        setHovered(desktop && !props.disabled && true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <span className="Listview__Filters__CheckBox__hidden">
        {svg(isChecked || (desktop && hovered))} {children}
      </span>
      <input type="checkbox" {...props} onChange={onChange} />
      <span className="Listview__Filters__CheckBox__checked">
        {svg(isChecked || (desktop && hovered))} {children}
      </span>
    </label>
  );
};

export default CheckBox;
